var React = require('react');
var $ = require('jquery');
var css = require('./module.scss');

var Tree = React.createClass( {

    componentDidMount() {
        const { setting, zNodes, treeid, onInit } = this.props;

        // 组件挂载时初始化树实例
        this.treeInst = $.fn.zTree.init($(`#${treeid}`), setting, zNodes);

        onInit && onInit(this.treeInst);

        if (setting.isExpand) {
            $.fn.zTree.getZTreeObj(treeid).expandAll(setting.isExpand);
        }
    },

    componentWillReceiveProps(nextProps) {
        const { treeid, treeUpdate } = this.props;
        const { setting, zNodes } = nextProps;

        if (treeUpdate !== nextProps.treeUpdate) {
            $.fn.zTree.destroy(treeid);
            $.fn.zTree.init($(`#${treeid}`), setting, zNodes);
        }

        if (setting.isExpand) {
            $.fn.zTree.getZTreeObj(treeid).expandAll(setting.isExpand);
        }
    },

    // filterZTree: function(keyword) {
    //     const { treeid } = this.props;
    //     let tree = this.treeInst;
    //     let nameKey = tree.setting.data.key.name;
    //     let childrenKey = tree.setting.data.key.children;

    //     let nodes = tree.getNodes();
    //     let reg = new RegExp(keyword);
    //     let _setNodes;
    //     (_setNodes = function(items) {
    //         tree.hideNodes(items);
    //         let expanded = false;
    //         for (let item, parent, i = 0, len = items.length; i < len; i++) {
    //             item = items[i];
    //             if (!keyword) {
    //                 tree.showNode(item);
    //                 item[childrenKey] && item[childrenKey].length && _setNodes(item[childrenKey]);
    //                 continue;
    //             }
    //             if (item[childrenKey] && item[childrenKey].length && _setNodes(item[childrenKey]) || reg.test(item[nameKey])) {
    //                 tree.showNode(item);
    //                 tree.expandNode(item, true);
    //                 expanded = true;
    //             } else {
    //                 tree.expandNode(item, false);
    //             }
    //         }
    //         return expanded;
    //     })(nodes);

    //     $.fn.zTree.getZTreeObj(treeid).expandAll(tree.setting.isExpand);
    // },

    componentWillUnmount() {
        const { treeid } = this.props;
        // 组件销毁时销毁树实例
        $.fn.zTree.destroy(treeid);
    },

    render() {
        const { treeid, classname } = this.props;
        return (
            <ul id={treeid} className={'fp-ztree ' + classname}></ul>
        );
    }
});

module.exports = Tree;



// WEBPACK FOOTER //
// ./component/tree/index.js